<div class="header" *ngIf="config.header">
  <p>{{ config?.header }}</p>
</div>
<div class="body text-center">
  <img class="img" *ngIf="config.img" [src]="config.img" alt="">

  <div class="title">{{ config.title }}</div>
  <div class="message" [innerHtml]="config.message"></div>

  <div class="d-flex justify-content-evenly mb-2">
    <button *ngIf="config.cancelText" mat-button class="invert" type="button"
      (click)="cancel()">{{ config.cancelText }}</button>
    <button mat-button type="button" class="" (click)="accept()">{{ config.buttonText }}</button>
  </div>

</div>
